import React from "react"
import styled from "@emotion/styled"

export const InteriorContent = styled.div`
margin-top: 40px;

h3{
    font-size: 2rem;
    color: #0e1f38;
    margin-bottom: 15px;
    font-family: 'Playfair Display';
    font-weight: 400;
    letter-spacing: 4px;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 0;
    text-transform: uppercase;
    @media(min-width: 537px){
        font-size: 50px;
    }
}
h1{
    color: #b6212a;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 14px;
    line-height: 24px;
    font-weight: 400; 
}
h4{
    color: #b6212a;
    margin-bottom: 30px;
    font-weight: 700;
    font-size: 1.5rem;
}
p{
    color: #444;
    font-size: 16px;
    line-height: 26px;
    margin-top: 0;
    margin-bottom: 1rem;
}
.row {
    display: flex;
    flex-wrap: wrap;
}
.video_bg_red{
    margin: 15px 0 84px 0;
    position: relative;
}
.video_bg_red img{
    width: 100%;
    height: 100%;
}
.vidio_icon{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
}
.bg_abs {
    right: 0;
    position: absolute !important;
    z-index: -1;
    bottom: -76px;
    width: 100%;
    height: 300px;
    @media(min-width: 992px){
            right: -105px;
    }
}
.video_bg_red .bg_abs span{
    bottom: 26px;
    position: absolute;
    left: 0;
    width: 100%;
    color: #fff;
    padding-left: 16px;
}
.content {
    margin-bottom: 30px;
}
.img_de {
    margin-bottom: 30px;
}
.experience_div {
    border-top: 1px solid #ccc;
    padding-top: 30px;
}
.experience_div h2 {
    color: #707783;
}
.highlight {
    color: #b6212a;
}
.consult_div {
    background: #0e1f38;
    padding: 40px 50px;
    color: #fff;
    margin: 40px 0 30px 0;
}
.consult_div h5 {
    line-height: 32px;
    margin-bottom: 30px;
    color: #fff;
}
.consult_div a{
    text-align: center;
    background: #b6212a;
    color: #fff;
    padding: 13px 34px;
    display: inline-block;
    line-height: 24px;
}
.consult_div .highlight a{
    display: inline;
    text-align: left;
    background: transparent;
    padding: 0;
  }
  .consult_div .highlight{
      color: #fff;
  }
  ul{
      list-style-type: none;
      padding-left: 0;
      margin-bottom: 1rem;
  }
  li{
    margin-bottom: 15px;
    align-items: baseline;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAABlBMVEVHcEy2ISoJ3drGAAAAAXRSTlMAQObYZgAAAB9JREFUCNdj4GFgkGNgsGdgKG5geHgAhIAMe7AgDwMAWkEF+4+rHKUAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-position-y: 4px;
    padding-left: 20px;
  }
  .iframeLinkContainer{
      width: 100%; margin-top: 20px;
  }
  @media(min-width: 768px){
    .col-md-4 {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
        padding-right: 15px;
    }
    .col-md-8 {
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
        padding-left: 15px;
    }
  }
  .col-12, .col-lg-6, .col-md-4{
    position: relative;
    width: 100%;
    min-height: 1px;
  }
  @media(min-width: 992px){
    .col-lg-9 {
        flex: 0 0 75%;
        max-width: 75%;
    }
    .col-lg-6 {
        flex: 0 0 50%;
        max-width: 50%;
    }
  }
  .sc-bwzfXH.row.uTxCW{
      margin-bottom: 30px;
  }
`